export default __webpack_public_path__ + "static/media/DesktopLine1.e2852b5b.svg";